import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const DropdownArrowUpIcon = (props: IProps) => {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 6.5L6 1.5L1 6.5"
        stroke={props.color || '#789B73'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default DropdownArrowUpIcon;
